import { Component, inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { AppInitAuthManagerService } from '@meddev/fe-shared';
import { Helpers } from '../../helpers';

@Component({
    selector: 'app-logout',
    template: '',
    encapsulation: ViewEncapsulation.None,
})
export class LogoutComponent implements OnInit {
    private injector = inject(Injector);

    ngOnInit(): void {
        Helpers.setLoading(true);
        const appInitAuthManager = this.injector.get(AppInitAuthManagerService);
        appInitAuthManager.performLogout(true, true);
    }
}
